
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auxilia",
      function () {
        return require("private-next-pages/auxilia/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auxilia"])
      });
    }
  